export function getTimeFromSeconds(seconds: number) {
  const time = new Date(1000 * Number(seconds)).toISOString().substr(11, 8);

  if (time.startsWith('00:')) {
    return time.substr(3);
  } else {
    return time;
  }
}
